/* NOSEKNOWS bg text — vHash
   - SHA-256 fragments appear only on nk:burst
   - never show full 64 chars
*/

(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var container = document.createElement("div");
  container.className = "nk-bgtext";
  document.body.appendChild(container);

  function rand(min, max){
    return min + Math.random() * (max - min);
  }

  function spawnLine(text, cls){
    var el = document.createElement("div");
    el.className = "nk-bgtext-line " + (cls || "");
    el.textContent = text;
    el.style.top = rand(22, 72) + "vh";
    el.style.left = "0";
    el.style.animation = "nk-drift " + rand(12, 22) + "s linear forwards";
    container.appendChild(el);
    setTimeout(function(){ el.remove(); }, 24000);
  }

  function sha256Hex(input){
    return crypto.subtle.digest("SHA-256", new TextEncoder().encode(input))
      .then(function(buf){
        return Array.from(new Uint8Array(buf))
          .map(function(b){ return b.toString(16).padStart(2, "0"); })
          .join("");
      });
  }

  function fragment64(full64){
    var start = Math.floor(Math.random() * (64 - 8));
    return "\u2026" + full64.slice(start, start + 8) + "\u2026";
  }

  // 副レイヤー: burst時のみSHA-256断片を1-2行表示
  document.addEventListener("nk:burst", function(){
    var seed = Date.now() + "-" + Math.random();
    sha256Hex(seed).then(function(full){
      var lines = 1 + Math.floor(Math.random() * 2);
      for (var i = 0; i < lines; i++){
        spawnLine(fragment64(full), "hash");
      }
    });
  });

})();
